import {
  RemoveInvitationModalProps as _RemoveInvitationModalProps,
  RemoveInvitationModalDataProps,
} from "./remove-invitation-modal-view";
import {
  PickReduxDispatchProps,
  PickReduxStateProps,
} from "../../../util/typeUtil";
import { ActionSender } from "../../../model/ActionSender";
import { AppState } from "../../../store/AppState";
import InProgressUtils from "../../../utils/in-progress";
import OrganizationUtils from "../../../utils/organization";
import { addSenderArgument } from "../../../actions/actionHelpers";
import {
  clearError,
  deleteOrganizationGroupInvitation,
  getOrganizationsOrganizationGroupInvitation,
} from "../../../actions";
import { connect } from "react-redux";
import RemoveInvitationModal from "./remove-invitation-modal-container";

export interface RemoveInvitationModalProps
  extends Omit<
    _RemoveInvitationModalProps,
    keyof RemoveInvitationModalDataProps
  > {}

// Input props provided to the wrapped component by this connect component, using mapStateToProps
type ReduxStateProps = PickReduxStateProps<
  _RemoveInvitationModalProps,
  RemoveInvitationModalProps
>;
// Dispatch props provided to the wrapped component by this connect component
type ReduxDispatchProps = PickReduxDispatchProps<
  _RemoveInvitationModalProps,
  RemoveInvitationModalProps
>;
const sender: ActionSender = { key: "remove-invitation" };

function mapStateToProps(
  state: AppState,
  ownProps: RemoveInvitationModalProps
): ReduxStateProps {
  return {
    isReady: InProgressUtils.selectNotInProgress(sender.key, state),
    invitation: ownProps.invitationId
      ? OrganizationUtils.selectOrganizationInvitation(
          ownProps.invitationId,
          state
        )
      : undefined,
  };
}

function areStatesEqual(next: AppState, prev: AppState): boolean {
  return (
    InProgressUtils.compareInProgressStates(next, prev) &&
    OrganizationUtils.compareOrganizationInvitationsStates(next, prev)
  );
}

const dispatchActions: ReduxDispatchProps = {
  onRemoveInvitation: addSenderArgument(
    sender,
    deleteOrganizationGroupInvitation
  ),
  onLoadInvitation: addSenderArgument(
    sender,
    getOrganizationsOrganizationGroupInvitation
  ),
  onClearError: clearError,
};
export default connect<
  ReduxStateProps,
  ReduxDispatchProps,
  RemoveInvitationModalProps,
  AppState
>(mapStateToProps, dispatchActions, null, {
  areStatesEqual,
})(RemoveInvitationModal);
